import React, { useState, useEffect } from "react";
import Multiselect from "multiselect-react-dropdown";
import masterApi from "../../services/masterApi";
import { useForm, Controller } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import IconUploadIcon from "../../assets/icons/IconUploadIcon";
import "./ManageStages.scss";
import {RecordStatusEnum} from "../../enum/enums";
import Loader from "../../components/loader/Loader";

const CreateStage = ({ close, existingData, onSave }) => {
  const apiBaseUrl = process.env.REACT_APP_API_URL;
  const [expertise, setExpertise] = useState([]);
  const [error, setError] = useState(null)
  const [viewLoader, setViewLoader] = useState(false);
  const { control, handleSubmit,setValue, register, formState: { errors } } = useForm({
    defaultValues: existingData
  });
  const [isEditMode, setIsEditMode] = useState(existingData);
  const STAGE_SUCCESS_MESSAGE = process.env.REACT_APP_STAGE_SUCCESS_MESSAGE
  const STAGE_UPDATE_SUCCESS_MESSAGE = process.env.REACT_APP_STAGE_UPDATE_SUCCESS_MESSAGE
  const [createItemForm, setCreateItemForm] = useState({
    Files: [],
    ImageValue: null,
    Image: null,
  });  
  const [imagePreview, setImagePreview] = useState(null);
  const [isChecked, setIsChecked] = useState(true);
 
  const fetchData = async () => {
    try {
      const response = await masterApi.getAllExpertise()
      setExpertise(response?.data?.expertiseList?.filter(item => item.recordStatus === RecordStatusEnum.ACTIVE)?.map(item => ({
        id: item._id,
        name: item.expertiseName
      })));
      if (existingData) {
        let imgurl =    existingData.stageImagePath;
        let timestamp = new Date().getTime();
        let cacheBypassUrl = `${imgurl}?t=${timestamp}`

        setImagePreview(apiBaseUrl + cacheBypassUrl);
        setValue('expertiselist', existingData?.expertises?.map(item => ({
          id: item._id, // or any unique identifier
          name: item.expertiseName, // or the property you want to display
        })));

        setIsChecked(existingData?.recordStatus == RecordStatusEnum.ACTIVE ? true : false )
      }
    } catch (error) {
      setError(error.message);  // Handle any errors that occur during fetch
    } finally {
      setViewLoader(false)  // Set loading to false when data fetching is complete
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  const onSubmit = async (data) => {
    setViewLoader(true)
    let formattedData = {
      expertiseId: data.expertiselist ? data.expertiselist.map(option => option.id) : [],
      roStageName: data.roStageName,
      recordStatus: isChecked ? RecordStatusEnum.ACTIVE : RecordStatusEnum.IN_ACTIVE,
    };
    if (!isEditMode) {
      const response = await masterApi.createStage({ formattedData });

      if (response?.data?.ok) {//sucessfully added   
          const formData = new FormData();          
          const stageid=response?.data?.id;
          formData.append("stageid", stageid);
          formData.append("image", data.image[0]);
          const response2 = await masterApi.uploadStageImage({ formData });    
          setViewLoader(false);      
        toast.success(STAGE_SUCCESS_MESSAGE, {
          autoClose: 1000, // 1 seconds, {
          onClose: () => {
            existingData=null;
            close(); // Close after the toast ends            
          }
        });
      } else {        
        setViewLoader(false)
        toast.error(response?.response?.data?.message, {
          autoClose: 2000, // 1 seconds
        })
      }
    }
    else {
      //const formData = new FormData();      
      const stageId = existingData?._id;   
      //console.log(data.image[0]) ;
      /*formData.append("stageid", stageId);
      formData.append("image", data.image[0]);
      const response2 = await masterApi.uploadStageImage({ formData });*/


      const updateResponse = await masterApi.updateStage({ stageId, formattedData });
      if (updateResponse?.ok) {//sucessfully added 
        if(data.image[0]){
          const formData = new FormData(); 
          console.log(stageId) ;        
          formData.append("stageid", stageId);
          formData.append("image", data.image[0]);
          const response2 = await masterApi.uploadStageImage({ formData });
        }
          // setTimeout(() => {
          setViewLoader(false);
        // }, 3000); 
        toast.success(STAGE_UPDATE_SUCCESS_MESSAGE, {
          autoClose: 1000, // 1 seconds, {
          onClose: () => {
            existingData=null;
            close(); // Close after the toast ends
          }
        });
      }
      else {
        setViewLoader(false)
        toast.error(updateResponse?.response?.data?.message, {
          autoClose: 2000, // 1 seconds
        })        
      }
    }
    { onSave() }
  };
  const onImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };


  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="popIn-inner-wrapper">
        <div className="create-stage d-flex flex-column justify-content-between h-100">
          <div className="form">
            <div className="form-group">
              <label>Stage Name<span>*</span></label>
              <input
                type="text"
                className={`form-control ${errors.roStageName ? 'required' : ''}`}
                {...register('roStageName', { required: true })}
                placeholder="Stage Name"
              ></input>
            </div>
            <div className="form-group">
              <label>Expertise<span>*</span></label>
              <div className="expertise">
                <Controller
                  name="expertiselist"
                  control={control}
                  defaultValue={[]} // Set default value as an empty array
                  rules={{ required: 'Please select at least one expertise.' }}
                  render={({ field: { onChange, value } }) => (
                    <Multiselect
                      options={expertise} // Options to display in the dropdown
                      selectedValues={value} // Preselected value to persist in dropdown
                      onSelect={(selectedList) => onChange(selectedList)} // Function will trigger on select event
                      onRemove={(selectedList) => onChange(selectedList)} // Function will trigger on remove event
                      displayValue="name" // Property name to display in the dropdown options
                      style={{
                        searchBox: {
                          border: errors.expertiselist ? '1px solid red' : '1px solid #ccc', // Highlight if required and not selected                
                        },
                      }}
                    />
                  )}
                />
              </div>
            </div>
          <div className="form-group upload-icon">
            <label>Stage Icon<span>*</span></label>
            <div className="uploadButton">
              {createItemForm.ImageValue && createItemForm.Image === null && (
                <img
                  src={`data:${createItemForm.ImageValue};base64,${createItemForm.ImageValue}`}
                  alt="Uploaded Icon"
                />
              )}

              {!imagePreview && (
                <div className={`uploadTrigger ${errors.image ? 'errorStyle' : ''}`}>
                  <div className="icon">
                    <IconUploadIcon />
                  </div>
                </div>
              )}

              {imagePreview && (
                <div className="dpDisplay">
                  <img src={imagePreview} alt="Preview" />
                </div>
              )}

              <input
                {...register("image", { required: !existingData?.stageImagePath ? 'Please upload an image.' : false })}
                type="file"
                accept="image/*"
                onChange={(e) => {
                  onImageChange(e);
                  register("image").onChange(e);
                }}
              />              
            </div>
          </div>
            
            <div className="form-group status">
              <label>Status<span>*</span></label>
              <label className="toggle-label">
                <input type="checkbox" {...register("recordStatus")}
                checked={isChecked}
                onChange={handleCheckboxChange}/>
                <div className="back">
                  <div className="toggle"></div>
                  <div className="label on">Active</div>
                  <div className="label off">Inactive</div>
                </div>
              </label>
            </div>            
          </div>
          {error && <div style={{ color: "red" }} className="alert space-between">{error}</div>}
          {viewLoader && <Loader />}
          <div className="action-btn">
            <button className="cancel secondary-btn" onClick={close}>Cancel</button>
            <button className="save primary-btn" >{isEditMode ? 'Update' : 'Save'}</button>
          </div>
        </div>
      </div>
    </form>    
  );
};

export default CreateStage;
